<template>
  <div class="container map-frame">
    <div class="row">
      <div class="col">
        <div
          ref="map-container"
          class="map-container"
        >
          <client-only>
            <gmap-map
              ref="map"
              class="map"
              :options="{ disableDefaultUI: true, gestureHandling: 'none', zoomControl: false }"
              :center="{ lat: 39, lng: -96 }"
              :zoom="4.8"
            >
              <gmap-marker
                v-for="airport in homeMap.airports"
                :key="airport.locationId"
                :label="`${airport.shares.length}`"
                :position=" { lat: airport.lat, lng: airport.long }"
                :icon="{ url: 'data:image/png;base64,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' }"
                @click="mapClick(airport)"
              />
            </gmap-map>
          </client-only>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  FETCH_GEO_LOCATION,
  FETCH_HOME_MAP
} from '@/store/action-types';

export default {
  data() {
    return {
      homeMap: this.$store.state.homeMap,
      WEB_URL: process.env.WEB_URL
    };
  },

  async created() {
    await this.$store.dispatch(FETCH_GEO_LOCATION);
    await this.$store.dispatch(FETCH_HOME_MAP);
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.resize);
      this.$refs.map.$mapPromise.then(() => {
        this.resize();
      });
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },

  methods: {
    mapClick(airport) {
      window.top.location.href = `${this.WEB_URL}/find?lat=${airport.lat}&lng=${airport.long}`;
    },

    resize() {
      if (this.$refs.map) {
        this.$refs.map.fitBounds({
          north: 50,
          south: 24,
          east: -65,
          west: -124
        }, 0);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.map-container {
  position: relative;
  width: 100%;
}

.map {
  position: relative;
  padding-bottom: calc(100% * 9 / 16);
}

.map > div {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
